module.exports = __webpack_public_path__ + "img/42.078a5b13.png";